import FormInputText from './../Partials/FormInputText';
import FormInputTextArea from './../Partials/FormInputTextArea';
import MetaColumn from './MetaColumn';
import GeneralForm from './../Forms/GeneralForm';

const ContactUsPageBuilder = {
    component: GeneralForm,
    options: {
        columns: {
            meta: MetaColumn,
            contents: [
                {
                    field: "address",
                    partial: {
                        handler: FormInputText,
                        props: {
                            initialValue: (formHandler)=> {
                                return formHandler.getArrayInputValue("contents", "address");
                            },
                            required: false,
                            label: "آدرس"
                        }
                    }
                },
                {
                    field: "telephone",
                    partial: {
                        handler: FormInputText,
                        props: {
                            initialValue: (formHandler)=> {
                                return formHandler.getArrayInputValue("contents", "telephone");
                            },
                            required: false,
                            label: "تلفن"
                        }
                    }
                },
                {
                    field: "email",
                    partial: {
                        handler: FormInputText,
                        props: {
                            initialValue: (formHandler)=> {
                                return formHandler.getArrayInputValue("contents", "email");
                            },
                            required: false,
                            label: "ایمیل"
                        }
                    }
                },
                {
                    field: "working",
                    sub_fields: [
                        {
                            field: "start",
                            sub_fields: [
                                {
                                    field: "day",
                                    partial: {
                                        handler: FormInputText,
                                        props: {
                                            initialValue: (formHandler)=> {
                                                return formHandler.getArrayInputValue("contents.working.start", "day");
                                            },
                                            required: false,
                                            label: "روز شروع به کار"
                                        }
                                    }
                                },
                                {
                                    field: "hour",
                                    partial: {
                                        handler: FormInputText,
                                        props: {
                                            initialValue: (formHandler)=> {
                                                return formHandler.getArrayInputValue("contents.working.start", "hour");
                                            },
                                            required: false,
                                            label: "ساعت شروع به کار"
                                        }
                                    }
                                },
                            ]
                        },
                        {
                            field: "end",
                            sub_fields: [
                                {
                                    field: "day",
                                    partial: {
                                        handler: FormInputText,
                                        props: {
                                            initialValue: (formHandler)=> {
                                                return formHandler.getArrayInputValue("contents.working.end", "day");
                                            },
                                            required: false,
                                            label: "یایان روز کاری"
                                        }
                                    }
                                },
                                {
                                    field: "hour",
                                    partial: {
                                        handler: FormInputText,
                                        props: {
                                            initialValue: (formHandler)=> {
                                                return formHandler.getArrayInputValue("contents.working.end", "hour");
                                            },
                                            required: false,
                                            label: "ساعت پایان کار"
                                        }
                                    }
                                },
                            ]
                        },
                    ]
                },
            ]
        }
    }
};

export default ContactUsPageBuilder;


// WEBPACK FOOTER //
// ./src/containers/Pages/Builders/ContactUsPageBuilder.js